export const dictFilter = function (value, list) {
  if(value && list){
    let item = list.find(i => i.value == value);
    if(item){
      return item.label;
    }else{
      return value;
    }
  }else{
    return "";
  }
};

